export const getType = (extension: string) => {
  switch (extension) {
    case 'mp4':
    case 'mov':
    case 'webm':
      return 'video';
    case 'jpg':
    case 'jpeg':
    case 'png':
    case 'gif':
    case 'svg':
    case 'webp':
      return 'image';
    default:
      return null;
  }
};
